var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBookOfComplains = function SvgBookOfComplains(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "book-of-complaints",
    x: "0px",
    y: "0px",
    viewBox: "0 0 161.9 68.5",
    enableBackground: "new 0 0 161.9 68.5",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 33.8,
    cy: 33.6,
    r: 32.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M6.6,28h1.3v9h4.3v1.1H6.6V28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M15,28v10.1h-1.3V28H15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M19.5,38.1L16.2,28h1.4l1.6,5c0.4,1.4,0.8,2.6,1.1,3.8h0c0.3-1.2,0.7-2.4,1.2-3.8l1.7-5h1.4l-3.6,10.1 H19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M25.6,28.1c0.7-0.1,1.6-0.2,2.5-0.2c1.4,0,2.3,0.3,2.9,0.8c0.5,0.4,0.8,1.1,0.8,1.9 c0,1.3-0.8,2.2-1.9,2.6v0c0.8,0.3,1.2,1,1.5,2c0.3,1.4,0.6,2.4,0.8,2.8h-1.3c-0.2-0.3-0.4-1.2-0.7-2.4c-0.3-1.4-0.8-1.9-2-2h-1.2 v4.4h-1.3V28.1z M26.9,32.7h1.3c1.4,0,2.3-0.8,2.3-1.9c0-1.3-0.9-1.9-2.3-1.9c-0.6,0-1.1,0.1-1.3,0.1V32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M42.4,33c0,3.5-2.1,5.3-4.7,5.3c-2.7,0-4.5-2.1-4.5-5.1c0-3.2,2-5.3,4.7-5.3C40.6,27.8,42.4,30,42.4,33z  M34.5,33.1c0,2.2,1.2,4.1,3.2,4.1c2.1,0,3.2-1.9,3.2-4.2c0-2-1-4.1-3.2-4.1C35.6,28.9,34.5,30.9,34.5,33.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M47.2,28.1C48,28,49,27.9,50,27.9c1.9,0,3.2,0.4,4.1,1.3c0.9,0.8,1.4,2,1.4,3.6c0,1.6-0.5,3-1.5,3.9 c-0.9,0.9-2.5,1.5-4.5,1.5c-0.9,0-1.7,0-2.4-0.1V28.1z M48.5,37.1c0.3,0.1,0.8,0.1,1.3,0.1c2.8,0,4.3-1.6,4.3-4.3 c0-2.4-1.3-3.9-4.1-3.9c-0.7,0-1.2,0.1-1.5,0.1V37.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M62.4,33.4h-3.9V37h4.4v1.1h-5.7V28h5.5v1.1h-4.1v3.2h3.9V33.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M67.8,28.1c0.7-0.1,1.6-0.2,2.5-0.2c1.4,0,2.3,0.3,2.9,0.8c0.5,0.4,0.8,1.1,0.8,1.9 c0,1.3-0.8,2.2-1.9,2.6v0c0.8,0.3,1.2,1,1.5,2c0.3,1.4,0.6,2.4,0.8,2.8H73c-0.2-0.3-0.4-1.2-0.7-2.4c-0.3-1.4-0.8-1.9-2-2h-1.2 v4.4h-1.3V28.1z M69.1,32.7h1.3c1.4,0,2.3-0.8,2.3-1.9c0-1.3-0.9-1.9-2.3-1.9c-0.6,0-1.1,0.1-1.3,0.1V32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M81,33.4h-3.9V37h4.4v1.1h-5.7V28h5.5v1.1h-4.1v3.2H81V33.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M90.2,37.8c-0.5,0.2-1.4,0.5-2.7,0.5c-2.8,0-5-1.8-5-5.1c0-3.2,2.1-5.3,5.3-5.3c1.3,0,2.1,0.3,2.4,0.4 l-0.3,1.1c-0.5-0.2-1.2-0.4-2-0.4c-2.4,0-3.9,1.5-3.9,4.2c0,2.5,1.4,4.1,3.9,4.1c0.8,0,1.6-0.2,2.1-0.4L90.2,37.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M91.9,28h1.3v9h4.3v1.1h-5.6V28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M100.6,34.9l-1,3.2h-1.3l3.4-10.1h1.6l3.4,10.1h-1.4l-1.1-3.2H100.6z M103.9,33.9l-1-2.9 c-0.2-0.7-0.4-1.3-0.5-1.8h0c-0.1,0.6-0.3,1.2-0.5,1.8l-1,2.9H103.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M116.6,33.7c-0.1-1.4-0.2-3.1-0.1-4.4h0c-0.3,1.2-0.8,2.4-1.3,3.8l-1.8,4.9h-1l-1.6-4.8 c-0.5-1.4-0.9-2.7-1.2-3.9h0c0,1.3-0.1,2.9-0.2,4.5l-0.3,4.3h-1.2l0.7-10.1h1.7l1.7,4.9c0.4,1.2,0.8,2.4,1,3.4h0 c0.3-1,0.6-2.1,1.1-3.4l1.8-4.9h1.7l0.6,10.1h-1.3L116.6,33.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M121.6,34.9l-1,3.2h-1.3l3.4-10.1h1.6l3.4,10.1h-1.4l-1.1-3.2H121.6z M124.9,33.9l-1-2.9 c-0.2-0.7-0.4-1.3-0.5-1.8h0c-0.1,0.6-0.3,1.2-0.5,1.8l-1,2.9H124.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M135.9,37.8c-0.5,0.2-1.4,0.5-2.7,0.5l-0.3,0.6c0.6,0.1,1,0.5,1,1.1c0,0.9-0.8,1.2-1.5,1.2 c-0.4,0-0.8-0.1-1.1-0.3l0.2-0.7c0.2,0.1,0.5,0.2,0.8,0.2c0.3,0,0.6-0.1,0.6-0.5c0-0.4-0.5-0.6-1.2-0.6l0.6-1.2 c-2.5-0.3-4.2-2.1-4.2-5.1c0-3.2,2.1-5.3,5.3-5.3c1.3,0,2.1,0.3,2.4,0.4l-0.3,1.1c-0.5-0.2-1.2-0.4-2-0.4c-2.4,0-3.9,1.5-3.9,4.2 c0,2.5,1.4,4.1,3.9,4.1c0.8,0,1.6-0.2,2.1-0.4L135.9,37.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M145.9,33c0,3.5-2.1,5.3-4.7,5.3c-2.7,0-4.5-2.1-4.5-5.1c0-3.2,2-5.3,4.7-5.3 C144.1,27.8,145.9,30,145.9,33z M138.1,33.1c0,2.2,1.2,4.1,3.2,4.1c2.1,0,3.2-1.9,3.2-4.2c0-2-1-4.1-3.2-4.1 C139.1,28.9,138.1,30.9,138.1,33.1z M139.4,27.4c0-0.9,0.4-1.5,1-1.5c0.3,0,0.6,0.1,0.9,0.3c0.2,0.1,0.5,0.3,0.7,0.3 c0.2,0,0.4-0.1,0.4-0.6h0.7c0,0.9-0.3,1.5-1,1.5c-0.3,0-0.6-0.1-0.9-0.3c-0.3-0.1-0.5-0.3-0.7-0.3c-0.2,0-0.4,0.3-0.4,0.7H139.4z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M152.8,33.4h-3.9V37h4.4v1.1h-5.7V28h5.5v1.1h-4.1v3.2h3.9V33.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M154.8,36.5c0.6,0.4,1.4,0.7,2.3,0.7c1.3,0,2.1-0.7,2.1-1.7c0-0.9-0.5-1.5-1.9-2 c-1.6-0.6-2.7-1.4-2.7-2.9c0-1.6,1.3-2.7,3.3-2.7c1,0,1.8,0.2,2.2,0.5l-0.4,1.1c-0.3-0.2-1-0.5-1.9-0.5c-1.4,0-1.9,0.8-1.9,1.5 c0,0.9,0.6,1.4,2,1.9c1.7,0.7,2.6,1.5,2.6,3c0,1.6-1.2,2.9-3.5,2.9c-1,0-2-0.3-2.6-0.6L154.8,36.5z"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBookOfComplains, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/book-of-complains.8f6ab89e.svg";
export { ForwardRef as ReactComponent };